import NiceModal from '@ebay/nice-modal-react';
import { Box, Loader, Text } from '@mantine/core';

import { useGetBotPages } from '../../api/getPages';

import { AddModal } from './AddModal';
import { BotPagesTable } from './Table';

import { AddButton } from '@/components';
import { useGetPages } from '@/features/pages';
import { Departments, Platforms } from '@/types';

type PagesListProps = {
  department: Departments;
};

export const PagesList = ({ department }: PagesListProps) => {
  const getTgPages = useGetPages({
    platform: Platforms.telegram,
    department,
  });
  const getInstPages = useGetPages({
    platform: Platforms.instagram,
    department,
  });
  const { data, isLoading, isError } = useGetBotPages({ department });

  if (isLoading || getTgPages.isLoading || getInstPages.isLoading) {
    return <ListLoader />;
  }

  if (isError) {
    return <Text c="red">Failed to load pages</Text>;
  }

  if (!data?.pages.length) {
    return <ListAddButton department={department} />;
  }

  const appPagesData = [...(getTgPages.data?.pages ?? []), ...(getInstPages.data?.pages ?? [])];

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: '1fr auto' }}>
      <Box style={{ overflow: 'auto', minHeight: 0 }}>
        <BotPagesTable department={department} pages={data.pages} appPagesData={appPagesData} />
      </Box>
      <ListAddButton department={department} size={56} />
    </Box>
  );
};

function ListLoader() {
  return (
    <Box
      style={{
        display: 'flex',
        height: 'calc(100vh - 105px)',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Loader size="xl" />
    </Box>
  );
}

function ListAddButton({ department, size }: { department: Departments; size?: number }) {
  return (
    <AddButton
      size={size}
      onClick={() =>
        NiceModal.show(AddModal, {
          page: {
            department,
            name: '',
            externalId: '',
            appPages: [],
          },
        })
      }
    />
  );
}
